import { render, staticRenderFns } from "./RightAmerican.vue?vue&type=template&id=99b2129c"
import script from "./RightAmerican.vue?vue&type=script&lang=js"
export * from "./RightAmerican.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports